"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateTo = void 0;
/**
 * Wrapper for window.location changes, literally only exists to aid with tests
 */
const navigateTo = location => {
  window.location.assign(location);
};
exports.navigateTo = navigateTo;